import enviro from 'enviro';
import { CSAT_SUBMISSIONS } from 'ui-forms-components/constants/FeedbackSurveys';
export const getFeedbackSurveyForEnviro = CSAT_SURVEY => enviro.isQa() ? CSAT_SURVEY.QA : CSAT_SURVEY.PROD;
export const getSubmissionsSurvey = () => getFeedbackSurveyForEnviro(CSAT_SUBMISSIONS);